var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item.items &&
    Array.isArray(_vm.item.items) &&
    _vm.showMenuItem(_vm.item)
    ? _c(
        "v-menu",
        {
          key: _vm.item.href,
          attrs: {
            attach: "body",
            "open-on-hover": "",
            "nudge-top": "10",
            "offset-y": "",
            "content-class": "hm-content"
          }
        },
        [
          _c(
            "v-btn",
            {
              key: _vm.item.href,
              staticClass: "app-btn-mh",
              class: { "has-icon": _vm.item.showIcon, active: _vm.item.active },
              attrs: {
                slot: "activator",
                href: _vm.getHref(_vm.item),
                flat: "",
                title: _vm.item.title
              },
              slot: "activator"
            },
            [
              _vm.item.showIcon
                ? _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v(_vm._s(_vm.item.icon))
                  ])
                : _vm._e(),
              _vm._v("\n    " + _vm._s(_vm.item.title) + "\n  ")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list",
            { staticClass: "app-hm-list" },
            _vm._l(_vm.item.items, function(child, childIndex) {
              return _c(
                "v-list-tile",
                { key: _vm.item.href + "-" + childIndex },
                [
                  _c("app-h-menu", {
                    attrs: {
                      item: child,
                      showIcon: _vm.showIcon,
                      showMenuItemFn: _vm.showMenuItem
                    }
                  })
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    : !_vm.item.divider &&
      !_vm.item.header &&
      !_vm.item.notInHeader &&
      _vm.showMenuItem(_vm.item)
    ? _c(
        "v-btn",
        {
          key: _vm.item.href,
          staticClass: "app-btn-mh",
          class: { "has-icon": _vm.item.showIcon, active: _vm.item.active },
          attrs: {
            href: _vm.getHref(_vm.item),
            title: _vm.item.title,
            flat: ""
          }
        },
        [
          _vm.item.showIcon
            ? _c("v-icon", { attrs: { large: "", left: "" } }, [
                _vm._v(_vm._s(_vm.item.icon))
              ])
            : [_vm._v("\n    " + _vm._s(_vm.item.title) + "\n  ")]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a7abbdbe", { render: render, staticRenderFns: staticRenderFns })
  }
}